import { lud, rule } from "../core/rule";

export const logPermissions = { view: "log.view" };

export const logGrants = { "log.view": rule(lud()) };
